import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Object Sources',
  basePath: '/itemserver-object-sources',
  columns: [
    { key: 'source', label: 'Source', sortable: true },
  ],
  fields: [
    { key: 'source', label: 'Source', type: 'text', required: true },
  ],
});
